import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-bar-chart-inactive-age',
  templateUrl: './bar-chart-inactive-age.component.html',
  styleUrls: ['./bar-chart-inactive-age.component.css']
})
export class BarChartInactiveAgeComponent implements OnInit {
  
            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription2: Subscription;
            subscription3: Subscription;
            subscription4: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            title = "Fascia d'età";
            destination = 'inactive';
  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartInactivePatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            inactiveGlobal020 = 0;
            inactiveGlobal2040 = 0;
            inactiveGlobal4060 = 0;
            inactiveGlobal60more = 0;
  
      
            activeGlobal020 = 0;
            activeGlobal2040 = 0;
            activeGlobal4060 = 0;
            activeGlobal60more = 0;
  
      
      
            GlobalPatients020 = 0;
            GlobalPatients2040 = 0;
            GlobalPatients4060 = 0;
            GlobalPatients60more =0;
     
      
            inactiveGlobalPatientsArray = [];
            activeGlobalPatientsArray = [];
            inactivePatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalInactive = ['0-20', '20-40','40-60','60+'];
            public barChartTypeGlobalInactive = 'horizontalBar';
            public barChartLegendGlobalInactive = true;
            public barChartDataGlobalInactive = [
              {
                data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal','teal', 'teal'],
                hoverBackgroundColor: ['#066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered', 'orangered','orangered','orangered'],
                hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription6 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
                this.retrieveGlobalInactive020();
              });
            }
            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription2.unsubscribe();
              this.subscription3.unsubscribe();
              this.subscription4.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
            
            retrieveGlobalInactive020() {
              this.subscription1 = this.doctorService.getInactiveAgeBracketsNumber("0","20").subscribe(npatients => {
                this.inactiveGlobal020 = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobal020); // riempio il vettore del bar chart con standard
                this.retrieveGlobalInactive2040();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
            retrieveGlobalInactive2040() {
              this.subscription2 = this.doctorService.getInactiveAgeBracketsNumber("20","40").subscribe(npatients => {
                this.inactiveGlobal2040 = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobal2040); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactive4060();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalInactive4060() {
              this.subscription3 = this.doctorService.getInactiveAgeBracketsNumber("40","60").subscribe(npatients => {
                this.inactiveGlobal4060 = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobal4060); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactive60more();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
    
            retrieveGlobalInactive60more() {
              this.subscription4 = this.doctorService.getInactiveAgeBracketsNumber("60","1000").subscribe(npatients => {
                this.inactiveGlobal60more = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobal60more); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalAge();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
          
            retrieveGlobalAge() {
              this.subscription5 = this.doctorService.getGlobalAgeLoginExistsNumber().subscribe(num => {
                this.GlobalPatients020 = num[0];
                this.GlobalPatients2040 = num[1];
                this.GlobalPatients4060 = num[2];
                this.GlobalPatients60more = num[3];
    
                this.activeGlobal020 = this.GlobalPatients020 - this.inactiveGlobal020;
                this.activeGlobalPatientsArray.push(this.activeGlobal020); // riempio il vettore del bar chart con standard           
                this.activeGlobal2040 = this.GlobalPatients2040 - this.inactiveGlobal2040;
                this.activeGlobalPatientsArray.push(this.activeGlobal2040); // riempio il vettore del bar chart con telemedicina
                this.activeGlobal4060 = this.GlobalPatients4060 - this.inactiveGlobal4060;
                this.activeGlobalPatientsArray.push(this.activeGlobal4060); // riempio il vettore del bar chart con standard           
                this.activeGlobal60more = this.GlobalPatients60more - this.inactiveGlobal60more;
                this.activeGlobalPatientsArray.push(this.activeGlobal60more); // riempio il vettore del bar chart con standard           
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {
                this.canvas = document.getElementById('myChartInactiveAge') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartInactivePatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalInactive,
                  data: {
                    labels: this.barChartLabelsGlobalInactive,
                    datasets: this.barChartDataGlobalInactive,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti attivi/inattivi",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          